export default class RouterState {
  previousRoute = String;
  currentRoute = String;

  to(route) {
    return this.previousRoute.set(this.current)
               .currentRoute.set(route);
  }

  get current() {
    return this.currentRoute.state;
  }

  get previous() {
    return this.previousRoute.state;
  }
}
